import { RouterProvider } from 'react-router-dom';
import { LanguageProvider } from './features/language/LanguageProvider';
import { PwaProvider } from './features/pwa/PwaProvider';
import { router } from './app/router';

export function App() {
  return (
    <LanguageProvider>
      <PwaProvider>
        <RouterProvider router={router} />
      </PwaProvider>
    </LanguageProvider>
  );
}
